import { gql, useMutation } from "@apollo/client";
import {
  CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteriaMutation,
  CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteriaMutationVariables,
} from "../../__generated__/graphql";

const CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteria = gql`
  mutation CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteria(
    $prompt: String!
    $expandContext: GenerateScoringCriteriaExpandContextInput
  ) {
    generateScoringCriteria(prompt: $prompt, expandContext: $expandContext)
  }
`;

const useGenerateScoringCriteria = () => {
  const [generateScoringCriteria, { loading }] = useMutation<
    CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteriaMutation,
    CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteriaMutationVariables
  >(CuratedSearchCriteriaAndFiltersContainer_GenerateScoringCriteria);

  return [generateScoringCriteria, { loading }] as const;
};

export default useGenerateScoringCriteria;
